<template>
  <div v-for="item in mainParameters" :key="item.id">
    <FilterTag
      :link="parameterValueQuery(item) === null ? null : translatePath(ROUTES.CODE.CATALOGUE) + `?c[${item.parameter.id}]=${encodeURIComponent(parameterValueQuery(item))}`"
      :on-click="async () => await handleClick(item)"
    >
      {{ item?.parameter?.input === 'number' || item?.parameter?.input === 'text' ? parameterValueLabel(item) : item?.note || parameterValueLabel(item) }}
    </FilterTag>
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import { parameterValueLabel, parameterValueQuery } from '@utils/parameters';
import { ROUTES } from "@utils/routes";
import FilterTag from "@components/filter/filter-tag";

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
});

const { $eventBus } = useNuxtApp();

const mainParameters = computed(() => _.filter(props.data?.parameters || [], item => item?.parameter?.type === 'main'));

const closeModal = () => {
  $eventBus.emit('modal:close');
}

const handleClick = async (item) => {
  const value = parameterValueQuery(item);
  if (value === null) return;
  closeModal();
  await useSearchParam(`c[${item.parameter.id}]`, value);
}

</script>
